import {ACTION_TYPE} from '../../core/redux/actionType';
import {ApiReducer, makeApiAction, makeApiReducer, RsaaTypes} from '../../core/redux/api/reduxStandardApiAction';
import {IAppState} from '../../core/redux/IAppState';
import {apiBlockUser} from '../../core/redux/api/endpoints';
import {hasTrippedBreaker, updateBreaker} from '../../core/redux/api/circuitBreaker/module';
import {addError, addLoading, getLoading, removeLoadingAndError} from '../../core/redux/api/module';
import {User} from './user';
import {assoc, updateIn} from '../../language/module';
import { getResource } from '../../language/resources/getResource';

export const KEY_ACTION = ACTION_TYPE.BLOCK_USER_REQUEST;
export const ACTIONS    = [
  ACTION_TYPE.BLOCK_USER_REQUEST,
  ACTION_TYPE.BLOCK_USER_RESPONSE,
  ACTION_TYPE.BLOCK_USER_ERROR,
];

export const blockUserAction = (userId: string) => makeApiAction(
  {
    method:   'PUT',
    headers:  (state: IAppState) => ({
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: (state: IAppState) => apiBlockUser(state.userState.userId, state.selectedResort.resortId, userId),
    types:    ACTIONS.map(action => ({ type: action, meta: { userId } })) as RsaaTypes,
    bailout:  (state: IAppState) => hasTrippedBreaker(state, KEY_ACTION) || !!getLoading(state, userId, KEY_ACTION),
  },
);

const reducer: ApiReducer<User[]> = (state, action, error, isLoading, payload) => {

  if (isLoading) {
    return addLoading(state, KEY_ACTION, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, KEY_ACTION, KEY_ACTION, error || getResource(state.locale, 'BLOCK_USER_ACTION_ERROR'));
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, KEY_ACTION, KEY_ACTION);

  return assoc(
    'users',
    updateIn(
      user => ({...user, blocked: true}),
      user => user.userId === action.meta.userId,
      noLoadingOrError.users || [],
    ),
    noLoadingOrError,
  );
};


export const blockUserReducer = makeApiReducer(ACTIONS, KEY_ACTION, reducer);